// extracted by mini-css-extract-plugin
module.exports = {"dropdownSelector":"dropdown-selector_dropdownSelector__8Ng7S"};